export const WRITE_OFF_REASON = 'WriteOff_Reason';
export const WRITE_OFF_REASONS = [
  {
    code: 'DI',
    label: 'Disruption exchange',
    requiresAdditional: true
  },
  {
    code: 'OE',
    label: 'Operator error',
    requiresAdditional: true
  },
  {
    code: 'AC',
    label: 'Death / Illness / Injury',
    requiresAdditional: true
  },
  {
    code: 'EC',
    label: 'Eurostar changes to timetable',
    requiresAdditional: false
  },
  {
    code: 'EL',
    label: 'Delays',
    requiresAdditional: false
  },
  {
    code: 'FR',
    label: 'Fraud Team Chargeback',
    requiresAdditional: true
  },
  {
    code: 'FR',
    label: 'Fraud Team Code 10',
    requiresAdditional: true
  },
  {
    code: 'FR',
    label: 'Fraud Team Cancellation',
    requiresAdditional: true
  },
  {
    code: 'FR',
    label: 'Fraud Team eVoucher',
    requiresAdditional: true
  },
  {
    code: 'SE',
    label: 'System error',
    requiresAdditional: true
  },
  {
    code: 'CE',
    label: 'Customer error',
    requiresAdditional: true
  },
  {
    code: 'ST',
    label: 'Strike',
    requiresAdditional: false
  },
  {
    code: 'NS',
    label: 'NS Refund',
    requiresAdditional: true
  },
  {
    code: 'RE',
    label: 'Rail Europe Refund',
    requiresAdditional: true
  },
  {
    code: 'SF',
    label: 'SNCF Refund',
    requiresAdditional: true
  },
  {
    code: 'SB',
    label: 'SNCB Refund',
    requiresAdditional: true
  },
  {
    code: 'MI',
    label: 'Migrated Bookings',
    requiresAdditional: true
  },
  {
    code: 'GD',
    label: 'GDS Booking',
    requiresAdditional: true
  },
  {
    code: 'DC',
    label: 'Adyen Admin',
    requiresAdditional: true
  },
  {
    code: 'BT',
    label: 'Salesforce Bank Transfer',
    requiresAdditional: true
  },
  {
    code: 'DB',
    label: 'Deutsche Bahn Refund',
    requiresAdditional: true
  },
  {
    code: 'SW',
    label: 'SBB (Swiss Rail) Refund',
    requiresAdditional: true
  },
  {
    code: 'DS',
    label: 'DSB (Denmark) Refund',
    requiresAdditional: true
  },
  {
    code: 'CF',
    label: 'CFL (Luxembourg) Refund',
    requiresAdditional: true
  },
  {
    code: 'MA',
    label: 'MAV (Hungary) Refund',
    requiresAdditional: true
  },
  {
    code: 'BU',
    label: 'E4B Upgrade',
    requiresAdditional: true
  },
  {
    code: 'FP',
    label: 'Flexible Packages',
    requiresAdditional: true
  },
  {
    code: 'IC',
    label: 'Insurance Cancellation',
    requiresAdditional: true
  },
  {
    code: 'IL',
    label: 'Insurance Letter',
    requiresAdditional: true
  }
];

export const reasonCodeToLabel = (code, label) => {
  if (code === 'FR') {
    return label;
  }

  const reason = WRITE_OFF_REASONS.find((r) => r.code === code);

  if (reason) {
    return reason.label;
  }

  return null;
};
